import React from 'react';

export default class ConfirmModalPOS extends React.Component {
    render() {
        return (
            <div className={"custom-modal  center-xs"}
                 style={{zIndex: 1000000}}
                 ref={(ref) => {
                     this.$modal = window.$(ref)
                 }}
            >
                <div className={"overlay"}
                     onClick={() => {
                         if (this.props.onClose) {
                             this.props.onClose();
                         }
                         this.$modal.remove()
                     }}
                />
                <div className="ui segments pos-modal-confirm" style={{width: '60%'}}>
                    <div className={"ui segment"}>
                        <div className={"header"}>
                            <h1 className={"ui header"} style={{marginBottom: 0, textAlign: 'left', fontSize: '2rem'}}>
                                {this.props.title}
                            </h1>
                        </div>
                    </div>
                    <div className={"ui segment"}>
                        <div className="content" style={{textAlign: 'left', fontSize: '2rem', lineHeight: 2}}>
                            <p style={{margin: '1rem 0'}}>{this.props.content}</p>
                        </div>
                    </div>
                    <div className={"ui segment"}>
                        <div className={"flex row"}>
                            <div className={"right floated"}>
                                <button className={"ui button basic massive"}
                                        ref={(ref) => {
                                            this.$close = window.$(ref)
                                        }}
                                        onClick={() => {
                                            if (this.$close.hasClass('loading')) {
                                                return false;
                                            }
                                            this.$close.addClass('loading');
                                            if (this.props.onClose) {
                                                this.props.onClose();
                                            }
                                            this.$modal.remove();
                                        }}
                                        style={{marginRight: '2rem'}}
                                >
                                    {this.props.cancel_text || "ยกเลิก"}
                                </button>
                                <button className={"ui button green massive"}
                                        ref={(ref) => {
                                            this.$approve = window.$(ref)
                                        }}
                                        onClick={() => {
                                            if (this.$approve.hasClass('loading')) {
                                                return false;
                                            }
                                            this.$approve.addClass('loading');
                                            if (this.props.onApprove) {
                                                this.props.onApprove();
                                            }
                                            this.$modal.remove()
                                        }}
                                >
                                    {this.props.approve_text || "ดำเนินการ"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}